import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import IcBaselineKeyboardArrowDown from '~icons/ic/baseline-keyboard-arrow-down'
import { MetaTitle } from 'src/components/MetaTags'
import TrainLoraContent from 'src/components/TrainLora'
import TrainLoraIntro from 'src/components/TrainLora/TrainLoraIntro'
import { useMe } from 'src/services/helpers/user'

function ScrollHint() {
  const { t } = useTranslation(['trainlora'])
  const [visible, setVisible] = useState(true)
  const introRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 5000)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    const el = introRef.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(false)
      },
      { threshold: 0.1 },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <>
      {/* Sentinel element at the intro section */}
      <div ref={introRef} className="h-px" />
      {visible && (
        <div className="fixed bottom-20 inset-x-0 mx-auto w-fit z-20 flex items-center gap-0.5 animate-bounce pointer-events-none bg-white/95 dark:bg-neutral-900/95 backdrop-blur-md px-3 py-1.5 rounded-full shadow-lg border border-neutral-200 dark:border-neutral-700">
          <div className="flex flex-col items-center -space-y-2 text-violet-500">
            <IcBaselineKeyboardArrowDown className="size-4 opacity-40" />
            <IcBaselineKeyboardArrowDown className="size-4 opacity-70" />
            <IcBaselineKeyboardArrowDown className="size-4" />
          </div>
          <span className="text-sm font-medium text-neutral-700 dark:text-neutral-200">
            {t('trainlora:submit-form.intro-scroll-hint.label')}
          </span>
          <div className="flex flex-col items-center -space-y-2 text-violet-500">
            <IcBaselineKeyboardArrowDown className="size-4 opacity-40" />
            <IcBaselineKeyboardArrowDown className="size-4 opacity-70" />
            <IcBaselineKeyboardArrowDown className="size-4" />
          </div>
        </div>
      )}
    </>
  )
}

function TrainLoraPage() {
  const { t } = useTranslation(['common'])
  const { me } = useMe()

  return (
    <div>
      <MetaTitle content={t('common:meta.title.train-lora')} />
      {!me && <TrainLoraIntro />}
      <TrainLoraContent />
      {me && (
        <div className="pb-20">
          <ScrollHint />
          <TrainLoraIntro />
        </div>
      )}
      <div id="train-lora-footer-sentinel" className="h-1" />
    </div>
  )
}

export const Component = TrainLoraPage
